import { useState, useEffect, useCallback } from "react";
import api, { formatDate, formatCurrency } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, AlertTriangle, TrendingDown } from "lucide-react";

export default function LowStockAlertsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/products?limit=500").then(r => {
      const all = r.data.products || [];
      setProducts(all.filter(p => (p.current_stock || 0) <= (p.reorder_level || 5)));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="low-stock-page">
      <div className="mb-6">
        <h1 className="font-heading font-bold text-2xl text-[#1F2937]">Low Stock Alerts</h1>
        <p className="text-sm text-gray-500 mt-1">{products.length} product{products.length !== 1 ? "s" : ""} below reorder level</p>
      </div>
      {loading ? <div className="animate-pulse h-40 bg-gray-100 rounded-sm" /> : products.length === 0 ? (
        <Card className="border rounded-sm"><CardContent className="p-12 text-center text-gray-400"><Package className="w-10 h-10 mx-auto mb-3 opacity-40" /><p>No low stock alerts</p></CardContent></Card>
      ) : (
        <Card className="border rounded-sm shadow-sm"><div className="overflow-x-auto">
          <table data-testid="low-stock-table" className="w-full text-sm">
            <thead><tr className="border-b bg-gray-50/50">
              <th className="p-3 text-left text-xs font-semibold uppercase text-gray-500">SKU</th>
              <th className="p-3 text-left text-xs font-semibold uppercase text-gray-500">Product</th>
              <th className="p-3 text-right text-xs font-semibold uppercase text-gray-500">Current Stock</th>
              <th className="p-3 text-right text-xs font-semibold uppercase text-gray-500">Reorder Level</th>
              <th className="p-3 text-center text-xs font-semibold uppercase text-gray-500">Status</th>
            </tr></thead>
            <tbody>{products.map(p => {
              const stock = p.current_stock || 0;
              const level = p.reorder_level || 5;
              const critical = stock === 0;
              return (
                <tr key={p.product_id} className="border-b border-gray-100 hover:bg-gray-50/50">
                  <td className="p-3 font-mono text-xs">{p.sku || "-"}</td>
                  <td className="p-3 font-medium">{p.product_name}</td>
                  <td className="p-3 text-right font-semibold">{stock}</td>
                  <td className="p-3 text-right text-gray-500">{level}</td>
                  <td className="p-3 text-center">
                    <Badge className={`rounded-full text-xs border ${critical ? "bg-red-50 text-red-700 border-red-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>
                      {critical ? "Out of Stock" : "Low Stock"}
                    </Badge>
                  </td>
                </tr>
              );
            })}</tbody>
          </table>
        </div></Card>
      )}
    </div>
  );
}
